export default __webpack_public_path__ + "fluffy-cloud-silhouette.png";